module.exports = __webpack_public_path__ + "img/85f2bfce4cb0f4198985cb792d1c2536.png";